import { Check, Close } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import { CreateConversationFolderPayload } from "@rms-types/modules/conversation-folder/dto";
import { ConversationFolder } from "@rms-types/modules/conversation-folder/entities/conversation-folder";

import { useCreateConversationFolder } from "../../hooks/api";

import { ReactHookForm } from "@/components";
import { UsePostOptions } from "@/hooks";

interface ConversationFolderFormProps {
  onCancel: () => void;
  options?: UsePostOptions<ConversationFolder, CreateConversationFolderPayload>;
}

export function ConversationFolderForm({ onCancel, options = {} }: ConversationFolderFormProps) {
  const { createConversationFolder } = useCreateConversationFolder(options);

  const handleSubmit = (values: CreateConversationFolderPayload) => {
    createConversationFolder({ payload: values });
  };

  return (
    <ReactHookForm
      formSchema={[
        {
          type: "text",
          name: "name",
          variant: "outlined",
          sx: {
            "& .MuiOutlinedInput-root": {
              border: (theme) => `1px solid ${theme.palette.primary.main}`,
            },
          },
          slotProps: {
            htmlInput: {
              autoComplete: "new-password",
              form: {
                autocomplete: "off",
              },
            },
          },
          xs: 12,
          autoFocus: true,
        },
        {
          type: "box",
          children: (
            <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1} py={1}>
              <IconButton
                size="small"
                type="submit"
                sx={{
                  bgcolor: "primary.main",
                  borderRadius: "4px",
                  color: "common.white",
                  "&:hover": { bgcolor: "primary.main" },
                }}
              >
                <Check fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                onClick={onCancel}
                sx={{
                  bgcolor: "grey.500",
                  borderRadius: "4px",
                  "&:hover": { bgcolor: "grey.500" },
                }}
              >
                <Close fontSize="small" />
              </IconButton>
            </Stack>
          ),
          xs: 12,
        },
      ]}
      onSubmit={handleSubmit}
      getFormActions={() => null}
      gridProps={{ spacing: 0 }}
    />
  );
}
